// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"770f898e","151":"78bc2812","220":"d2e015ab","285":"f03df820","500":"afc32026","540":"8cff499b","772":"c0283763","885":"6b10093e"}[chunkId] + ".chunk.js";
};